import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faUser } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { toast } from 'react-hot-toast';
import { formatCurrency, getRate } from '../utils/currencyUtils';

function RWithdraw3() {
  const { user } = useUser();
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lsCode = localStorage.getItem('withdraw.withdrawCode');
    const hasType = state?.withdrawCode || lsCode;
    if (!hasType) {
        navigate('/rwithdraw2', { replace: true });
    } else {
        setLoading(false);
    }
  }, [state, navigate]);
  const [symbol, setSymbol] = useState(() => {return state?.symbol ?? localStorage.getItem('withdraw.symbol') ?? '';});
  const [price, setPrice] = useState(() => {return state?.price ?? localStorage.getItem('withdraw.price') ?? '';});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [type, setType] = useState(() => {return state?.type ?? localStorage.getItem('withdraw.type') ?? 'Crypto';});
  const [camount, setCamount] = useState(() => {return state?.camount ?? localStorage.getItem('withdraw.camount') ?? '';});
  const [asset, setAsset] = useState(() => {return state?.asset ?? localStorage.getItem('withdraw.asset') ?? 'BTC';});
  const [amount, setAmount] = useState(() => {return state?.amount ?? localStorage.getItem('withdraw.amount') ?? '';});
  const [address, setAddress] = useState(() => {return state?.address ?? localStorage.getItem('withdraw.address') ?? '';});
  const [paymentDetails, setPaymentDetails] = useState(() => {return state?.paymentDetails ?? localStorage.getItem('withdraw.paymentDetails') ?? '';});
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [paidfee, setPaidfee] = useState(() => {return state?.paidfee ?? localStorage.getItem('withdraw.paidfee') ?? '';});
  const [admin, setAdmin] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchadmin: true })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
            setAdmin(data.admin);
        }
    })
    .catch(err => {
    })
  }, [user]);
  const ValidateWithdraw = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_bank: true, amount: amount, paymentDetails: paymentDetails, wamount : amount})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading1(false);
        toast.success(data.result);
        setTimeout(() => {
          navigate('/transaction', { replace: true })
        }, 2000);
      }else{
        toast.error(data.message);
        setLoading1(false);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading1(false);
    })
  }
  const ValidateWithdraw1 = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_crypto: true, method: asset, price : price, amount: camount, wallet_address : address })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading1(false);
        toast.success(data.result);
        setTimeout(() => {
          navigate('/transaction', { replace: true })
        }, 2000);
      }else{
        setLoading1(false);
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading1(false);
    })
  }
  const [totalFee, setTotalFee] = useState(0);
  useEffect(() => {
    const withfee = (type === "Crypto" ? camount * price : amount) * (Number(admin.retirement_fee)/100);
    const swapfee = (type === "Crypto" ? 0 : amount * (0.5/100));
    const totalfee = withfee + swapfee;
    setTotalFee(totalfee);
  }, [admin, camount, price, amount, type]);
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Withdraw Funds</h5>
                        <p className="mb-0">Withdraw from from your account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/rwithdraw" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Method Selection</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Withdrawal Details</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Withdrawal Code</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h5 className="mb-2" style={{fontWeight:'900'}}>Review Your Deposit</h5>
                              <div className="mb-2 mycard p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <p className="mb-0 text-secondary fw-semibold">Method</p>
                                    <p className="mb-0 fw-bold">{type=="Crypto"? asset : type }</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-0 text-secondary fw-semibold">Amount </p>
                                    <p className="mb-0 fw-bold">{type === "Crypto" ? `${camount} ${symbol}` : `${formatCurrency(amount)} ${user?.currency}`}</p>
                                </div>
                              </div>
                              <p className="mb-1" style={{fontSize:'14px',fontWeight:'900'}}>Transaction Fee</p>
                              <div className="mb-2 mycard p-3">
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Withdrawal Fee</p>
                                    <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{formatCurrency((type === "Crypto" ? camount * price : amount) * (Number(admin.retirement_fee)/100))} {user?.currency}</p>
                                </div>
                                {type != "Crypto" && (
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Currency Swapping Fee: </p>
                                        <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{formatCurrency(amount * (0.5/100))} {user?.currency}</p>
                                    </div>
                                )}
                                <div className="d-flex align-items-center justify-content-between mt-3">
                                    <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Total Fee</p>
                                    <p className="mb-0 fw-bold">{formatCurrency(totalFee)} {user?.currency}</p>
                                </div>
                                {!paidfee && (
                                <div className="d-flex align-items-center justify-content-end mt-3">
                                    <Link to="/plandeposit" state={{fee: true, feeamount : totalFee}} className={`text-center px-3 py-2 rounded-2 noLink`} style={{border:'2px solid #ff6b35'}}>Pay Fees</Link>
                                </div>
                                )}
                              </div>
                              <div className="mycard p-3 rounded-2" style={{backgroundColor:'#ff6b350d'}}>
                                <p className="mb-0 text-prime" style={{fontSize:'14px'}}>Your withdraw will be review within 1-24 hours. You'll receive an email confirmation once approved.</p>
                              </div>
                              <hr/>
                              <div className="d-flex justify-content-end">
                                <div className={`myBtn mt-4 text-center px-4 py-3 rounded-2 ${!paidfee ? 'disabled' : null}`} onClick={paidfee? (type == "Crypto" ? ValidateWithdraw1 : type == "Bank Transfer" ? ValidateWithdraw : null) : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Submit Withdraw'}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default RWithdraw3